import { render } from "./Vision_working_group_Suggested_perspective.vue?vue&type=template&id=b5a74d2a&scoped=true"
import script from "./Vision_working_group_Suggested_perspective.vue?vue&type=script&lang=js"
export * from "./Vision_working_group_Suggested_perspective.vue?vue&type=script&lang=js"

import "./Vision_working_group_Suggested_perspective.vue?vue&type=style&index=0&id=b5a74d2a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5a74d2a"]])

export default __exports__